import { useState } from "react";
import { useLoyaltyPeriodsQuery } from "Api/Queries/Loyalty/useLoyaltyPeriodsQuery";
import { LoyaltyMonthDropdown } from "Components/Loyalty/Shared/PeriodSelect/LoyaltyMonthDropdown";
import { LoyaltyMonthDropdownSkeleton } from "Components/Loyalty/Shared/PeriodSelect/LoyaltyMonthDropdownSkeleton";

type Props = {
  onPeriodChange: (settlementPeriodId: number | undefined) => void;
};

export const LoyaltyPeriodSelector = ({ onPeriodChange }: Props) => {
  const [selectedPeriodId, setSelectedPeriodId] = useState<number>(); // undefined = no explicit selection → backend serves the current open period.
  const { data, isError, isLoading } = useLoyaltyPeriodsQuery();

  if (isLoading) {
    return <LoyaltyMonthDropdownSkeleton />;
  }

  const periods = data?.items;
  if (isError || !periods?.length) {
    return null;
  }

  const currentPeriodId = periods.find(
    ({ isCurrent }) => isCurrent,
  )?.settlementPeriodId;

  const selectValue = selectedPeriodId ?? currentPeriodId;

  const handlePeriodChange = (nextPeriodId: number) => {
    setSelectedPeriodId(nextPeriodId);
    const resolvedQueryPeriodId =
      nextPeriodId === currentPeriodId ? undefined : nextPeriodId;
    onPeriodChange(resolvedQueryPeriodId);
  };

  return (
    <LoyaltyMonthDropdown
      periods={periods}
      value={selectValue}
      onChange={handlePeriodChange}
    />
  );
};
